import { LoadingComponent, MasterPage } from "@components";
import { ProtocoloEntidade } from "@entidades";
import { buscarBloqueio, NumFuncionalidade } from "@helpers";
import { Alert, Box, Button, StaticField } from "@intech/web-ui";
import { ComprovantesService } from "@services";
import React, { useEffect, useState } from "react";
import { FaChevronLeft } from "react-icons/fa";
import { useHistory } from "react-router-dom";

export const ComprovanteDetalhe: React.FC<any> = ({ match, ...rest }) => {
  const history = useHistory();

  const [Loading, setLoading] = useState(false);
  const [Erro, setErro] = useState<string>("");
  const [MotivoBloqueio, setMotivoBloqueio] = useState<string>("");

  const [Comprovante, setComprovante] = useState<ProtocoloEntidade>(null);

  useEffect(() => {
    (async () => {
      let bloqueio = await buscarBloqueio(NumFuncionalidade.COMPROVANTES);
      if (bloqueio) setMotivoBloqueio(bloqueio);
      // await criarLog(DMN_FUNCIONALIDADE.COMPROVANTES);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);

      try {
        let comprovante = await ComprovantesService.BuscarPorOid(match.params.oid);
        setComprovante(comprovante);
      } catch (e) {
        const error: any = e;
        const messsage = error.response ? error.response.data : error;
        setErro(messsage);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <MasterPage title="Comprovante" {...rest}>
      <Button type="primary" className="mb-3" title="Voltar" icon={<FaChevronLeft />} onClick={() => history.goBack()} />

      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alert type="danger">{Erro}</Alert>}

      {!Loading && MotivoBloqueio && <Alert type="danger">{MotivoBloqueio}</Alert>}

      {!Loading && !Erro && !MotivoBloqueio && Comprovante && (
        <>
          <Box title={"Dados do Participante / Pensionista"}>
            <StaticField title="Nome" value={Comprovante.NOME_ENTID} labelSize={3} />
            <StaticField title="Plano" value={Comprovante.DS_PLANO ?? "TODOS"} labelSize={3} />
          </Box>

          <Box title="Dados da Transação">
            <StaticField title="Nome da Transação" value={Comprovante.DES_FUNCIONALIDADE} labelSize={3} />
            <StaticField title="Número de Protocolo" value={Comprovante.COD_IDENTIFICADOR} labelSize={3} />
            <StaticField title="Data da Solicitação" value={Comprovante.DS_DTA_SOLICITACAO} labelSize={3} />
            <StaticField title="Solicitado por" value={Comprovante.TXT_USUARIO_SOLICITACAO} labelSize={3} />
            <StaticField title="Data da Efetivação" value={Comprovante.DS_DTA_EFETIVACAO ?? "-"} labelSize={3} />
            <StaticField title="Efetivado por" value={Comprovante.TXT_USUARIO_EFETIVACAO ?? "-"} labelSize={3} />
            <StaticField title="Motivo da Recusa" value={Comprovante.TXT_MOTIVO_RECUSA} labelSize={3} />
          </Box>

          <Box title="Conteúdo da Transação">
            {Comprovante.ListaTransacao.map((itemTransacao, index) => (
              <StaticField key={index} title={itemTransacao.Titulo} value={itemTransacao.Valor} labelSize={3} />
            ))}
          </Box>

          <Box title="Dados Técnicos">
            <StaticField title="Endereço IPV4 Local" value={Comprovante.TXT_IPV4} labelSize={3} />
            <StaticField title="Endereço IPV4 Externo" value={Comprovante.TXT_IPV4_EXTERNO} labelSize={3} />
            <StaticField title="Endereço IPV6" value={Comprovante.TXT_IPV6} labelSize={3} />
            <StaticField title="Dispositivo" value={Comprovante.TXT_DISPOSITIVO} labelSize={3} />
            <StaticField title="Origem" value={Comprovante.TXT_ORIGEM} labelSize={3} />
          </Box>
        </>
      )}
    </MasterPage>
  );
};
